export const SWEEPS_CATEGORIES_KEY = 'sweepCategories';
